

// storeGuestZip = function () {
//     const zip = document.getElementById("zipInput").value;
//     if (!zip || zip.length !== 5 || isNaN(zip)) {
//       alert("Please enter a valid 5-digit ZIP code.");
//       return;
//     }

//     localStorage.setItem("buildabox_zip", zip);

// fetch('/cart/update.js', {
//   method: 'POST',
//   headers: {
//     'Content-Type': 'application/json'
//   },
//   body: JSON.stringify({
//     attributes: {
//       guest_zip: zip
//     }
//   })
// })};

  function updateMinOrderMessage() {
  var localZips = [
    89431, 89433, 89434, 89436, 89441, 89501, 89502, 89521,
    89439, 89503, 89506, 89508, 89509, 89511, 89512, 89519, 89523
  ];
  // Try to get ZIP from localStorage or a global variable
  var zip = localStorage.getItem('buildabox_zip');
// console.log("ZIP:", zip);
  if (!zip) return;

  zip = parseInt(zip);

  var $msg = $('.min-order-msg'); // jQuery selector

  if (!$msg.length) return; // stop if not found

  if (localZips.includes(zip)) {
    $msg.text("A minimum order value of $60 applies");
  } else {
    $msg.text("A minimum order value of $175 applies");
  }
//     console.log("Running ZIP check...");
// console.log("Found msg?", $msg.length);
}

 function getBuildBoxFromLocal() {
  const stored = localStorage.getItem('build_a_box');
  return stored ? JSON.parse(stored) : [];
}

 function saveBuildBoxToLocal(data) {
  localStorage.setItem('build_a_box', JSON.stringify(data));
   // console.log("updatingLocalWithBuildBox")
}

 function syncWithShopifyCart() {
  const items = getBuildBoxFromLocal();
  const serialized = JSON.stringify(items);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: {
        build_a_box: serialized
      }
    })
  });
 }

function updateLocalStorage(productId, product, image, price, newQuantity) {
  let existing = JSON.parse(localStorage.getItem("build_a_box")) || [];

  if (newQuantity === 0) {
    // Remove item from storage if quantity is 0
    existing = existing.filter(item => item.id !== productId);
  } else {
    const foundIndex = existing.findIndex(item => item.id === productId);
    if (foundIndex !== -1) {
      // Update quantity if item exists
      existing[foundIndex].quantity = newQuantity;
    } else {
      // Add new item
      console.log("updating localStorage")
      existing.push({
        id: productId,
        product: product,
        image: image,
        price: price,
        quantity: newQuantity,
      });
    }
  }

  saveBuildBoxToLocal(existing);  // Your wrapper for setItem
  syncWithShopifyCart();          // Keep cart in sync
}

  function syncQuantityInputs(productId, newCount) {
  $('quantity-input[data-id="' + productId + '"]').each(function () {
    const $input = $(this).find('.quantity__input');

    if ($input.length && $input.val() != newCount) {
      $input.val(newCount).trigger('change');
      console.log('syncing input', $input)
    }
  });
  }


  
$(document).ready(function(){

    //Changing radio selection
  $(".plan-flex input[type=radio]").change(function() {
    $('.plan-content').removeClass('checked');
    $(this).parent().parent().parent().addClass('checked');
    $('.plan__warning-text ').text('');
    $(this).parents(".build--step").find("button.button.step--button.next").trigger("click");
  });

  $(".plan.subscription-plan, .plan.one-time-plan").click(function(){
    $(this).parents(".build--step").find("button.button.step--button.next").trigger("click");
  })

  $("button.button.step--shop.prev, button.button.step--button.prev").click(function(){
    var step = Math.ceil($(this).data("prev"));
    var prev = step - 1;

    $(".options-set input[type='checkbox']:checked").trigger('click');


    $(".build--step[data-step='" + step + "']").removeClass("active");
    $(".build--step[data-step='" + prev + "']").addClass("active");
    $("section[id*=product-grid-" + step + "]").css('display', 'none');

    //For step progress
    $(".bstep").removeClass("active");
    $(".bstep").eq(prev).removeClass('finished').addClass("active");

    if( step === 1 ){
      $('[data-step="0"]').css('display', 'block');
    }

    //console.log(step)

    if(step > 1) {
      $("section[id*=product-grid-" + prev + "]").css({'display': 'flex', 'justify-content': 'center'});
      $(".build--box").css('display', 'none');
    } else {
      $(".build--box").css('display', 'block');
    }
  });
  $("button.button.step--shop.prev").click(function(){
    var step = Math.ceil($(this).data("prev"));
    var prev = step - 1;

    $(".build--step[data-step='" + step + "']").removeClass("active");
    $(".build--step[data-step='" + prev + "']").addClass("active");
    $("section[id*=product-grid-" + step + "]").css('display', 'none');

    //For step progress
    $(".bstep").removeClass("active");
    $(".bstep").eq(prev).removeClass('finished').addClass("active");

    if( step === 1 ){
      $('[data-step="0"]').css('display', 'block');
    }

    if( step === 2 ){
      $('[data-step="1"]').css('display', 'block');
      $('[data-step="0"]').css('display', 'none');
    }

    //console.log(step)

    if(step > 2) {
      $("section[id*=product-grid-" + prev + "]").css({'display': 'flex', 'justify-content': 'center'});
      $(".build--box").css('display', 'none');
    } else {
      $(".build--box").css('display', 'block');
    }
  });

  $("button.button.step--button.next").click(function(){
    var step = Math.ceil($(this).data("next"));
    var prev = step - 1;
    const canProceed = localStorage.getItem("buildabox_zip");
     if(!canProceed) return
    $(".options-set input[type='checkbox']:checked").trigger('click');


    $('.mobile__down-show button').on('click', function(){
      $('.desktop__up-show').toggleClass('openFilter');
    });


    // if($('.build--step.active .build--overview__wrap').children().length <= 0 && step != 1) {
    //   //alert("Please add at least 1 item to proceed.");
    //   $('.build--overviewcontent-empty p').text("Please add at least 1 item to proceed.");
    // } else 

    if (step == 1) {
  
    $(".build--step").removeClass("active");
    $(".build--step[data-step='" + prev + "']").removeClass("active").hide();
    $(".build--step[data-step='" + step + "']").addClass("active").show();
      // updateGridContents();

    $(".bstep").removeClass("active");
    $(".bstep").eq(step).addClass("active");
    if (step > 0) {
      $(".bstep").eq(step - 1).addClass("finished");
    }

  }
    if(step == 2) {
      var plan = $(".plan-flex input[type=radio]:checked").val();
      if(plan == 'one-time') {
        $('.build--overview__itemproduct').text('ONE TIME PURCHASE (MENU A LA CARTE)');
        $(".build--step").removeClass("active");

        $(".build--step").parent().removeClass("activeSelection");
        $(".build--step[data-step='" + step + "']").parent().addClass("activeSelection");

        $('.build--box + .stick__buttons').hide();

        $(".build--step[data-step='" + step + "']").addClass("active");
        $("section[id*=product-grid-" + step + "]").css('display', 'none');
        $("section[id*=product-grid-" + prev + "]").css({'display': 'flex', 'justify-content': 'center'});
        updateMinOrderMessage();
         CheckZipGridUpdate();
        // updateDestinationTrail();
        $(".build--box").css('display', 'none');
        $(window).scrollTop(0);

        //For step progress
        $(".bstep").removeClass("active");
        $(".bstep").eq(step).addClass("active");

        if(step > 0) {
          $(".bstep").eq(step - 1).addClass("finished");
        }


      } else if (plan == 'subscription') {
        window.location.href = "/pages/meal-plans";
        $('.plan__warning-text p').remove();
      } else {
        //alert('Please select a plan.');
        $('.plan__warning-text').text('PLEASE SELECT A PLAN BEFORE PROCEEDING.');
      }
    } else if(step == 3) {
      $(".build--step").removeClass("active");
      $(".build--step").parent().removeClass("activeSelection");
      $(".build--step[data-step='" + step + "']").parent().addClass("activeSelection");

      $(".build--step[data-step='" + step + "']").addClass("active").show();
      $("section[id*=product-grid-1]").css('display', 'none');
      $("section[id*=product-grid-" + prev + "]").css({'display': 'flex', 'justify-content': 'center'});
      updateMinOrderMessage();
      // updateDestinationTrail();
      
      //to add the previous items to the buil-step 2
      const $step1Items = $('section[id*=product-grid-1] .build--overview__items .overview-item');
      const $step2Wrap = $('section[id*=product-grid-2] .build--overview__wrap');
      $step2Wrap.empty();
      $step1Items.each(function () {
        const $item = $(this);
        const id = $item.data('id');
       const count = parseInt($item.find('.overview--count').text());
      const price = parseFloat($item.data('price'));
        
        // Check if already added in step 2 (avoid duplicates)
        const $existing = $step2Wrap.find('.overview-item[data-id="' + id + '"]');

        if ($existing.length > 0) {
          // Already exists — sync count and price
          const currentCount = parseInt($existing.find('.overview--count').text());
          const newCount = currentCount + count;
      
          $existing.find('.overview--count').text(newCount);
          $existing.data('price', price);
          syncQuantityInputs(id, newCount);
        } else {
          // Clone and append
          console.log("added item to g2:", $item, id)
          $step2Wrap.append($item.clone());
            syncQuantityInputs(id, count);
          
        }
      });

      // Convert cloned quantity-input custom elements to plain divs to prevent validateQtyRules from disabling buttons
      $step2Wrap.find('quantity-input').each(function() {
        var $qi = $(this);
        var $replacement = $('<div>').addClass($qi.attr('class') + ' overview-qty')
          .attr('data-image', $qi.data('image'))
          .attr('data-product', $qi.data('product'))
          .attr('data-id', $qi.data('id'))
          .attr('data-price', $qi.data('price'))
          .html($qi.html());
        $replacement.find('.quantity__button.box[name="minus"]').prop('disabled', false).removeClass('disabled');
        $qi.replaceWith($replacement);
      });

      $(".build--box").css('display', 'none');

      $(window).scrollTop(0);

      //For step progress
      $(".bstep").removeClass("active");
      $(".bstep").eq(step).addClass("active");

      if(step > 0) {
        $(".bstep").eq(step - 1).addClass("finished");
      }
      $('.build--overviewcontent-empty p').text("");
    } else if(step == 4){
      //For step progress
      $(".bstep").removeClass("active");
      $(".bstep").eq(step).addClass("active");
      $(".build--box").css('display', 'block');
      $('[data-step="0"]').css('display', 'none');
      $('[data-step="1"]').css('display', 'none');

      $(window).scrollTop(0);

      if(step > 0) {
        $(".bstep").eq(step - 1).addClass("finished");
      }

      $(".build--step").removeClass("active");
      $(".build--step[data-step='" + prev + "']").addClass("active").show();
      $("section[id*=product-grid]").css("display", "none");
      // syncQuantityInputs();

      
      //ADDS ALL ITEMS ON PREVIOUS STEPS
       const $summaryWrap = $('.build--step.summary .build--overview__wrap');
      const seenIds = new Set();
      const prices = [];
      
      $summaryWrap.empty(); // Clear previous items
      
      $('.build--step.active .build--overview__wrap .overview-item').each(function () {
        const $item = $(this);
        const productId = $item.data('id');
        const count = parseInt($item.find('.overview--count').text());
        const price = parseFloat($item.data('price'));
      
        if (!seenIds.has(productId)) {
          // Clone the item for safety
          const $clone = $item.clone();
      
          // Append fresh copy to summary wrap
          $summaryWrap.append($clone);
      
          // Sync quantity input
          syncQuantityInputs(productId, count);
      
          // Calculate running total
          prices.push(parseFloat(price) * count);
          // parseFloat($(this).data('price')) * count
      
          seenIds.add(productId);
          console.log("Added to summary:", productId, "count:", count);
        } else {
          // Already added, skip or optionally update quantity here
        }
      });


      var total = prices.reduce((partialSum, a) => partialSum + a, 0);
      $('.build--step.active .overview--total span').empty().text('$' + total.toFixed(2));

      $('.activeSelection .overview--total span').empty().text('$' + total.toFixed(2));

      $('.build--overviewcontent-empty p').text("");

      // Hide sticky bar when .build__last-step-row is in viewport
      var lastStepRow = document.querySelector('.build__last-step-row');
      var stickyBar = document.querySelector('.stick__buttons.hsb-ecomis');
      if (lastStepRow && stickyBar) {
        stickyBar.style.visibility = 'hidden';
        if (window._lastStepObserver) window._lastStepObserver.disconnect();
        window._lastStepObserver = new IntersectionObserver(function(entries) {
          stickyBar.style.visibility = entries[0].isIntersecting ? 'hidden' : 'visible';
        }, { threshold: 0 });
        window._lastStepObserver.observe(lastStepRow);
      }
      }

  });

  var ctr = 0;
  (function initBuildBoxCounter() {
    const storedBox = localStorage.getItem("build_a_box");
    if (!storedBox) return;

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        if (cartData.item_count === 0) {
          localStorage.removeItem('build_a_box');
          ctr = 0;
          return;
        }
        const items = JSON.parse(storedBox);
        ctr = items.reduce((total, item) => {
          return total + parseInt(item.quantity);
        }, 0);
      })
      .catch(function() {
        const items = JSON.parse(storedBox);
        ctr = items.reduce((total, item) => {
          return total + parseInt(item.quantity);
        }, 0);
      });
  })();
  var pricing = [];

  //BUILD A BOX QUANTITY ADD
 $(document).on("click", '.quantity__button.box[name="plus"]', function(){
    var id = $(this).parent().data('id');
    var image = $(this).parent().data('image');
    var product = $(this).parent().data('product');
    var price = $(this).parent().data('price');

    $(this).siblings('.quantity__button.box[name="minus"]').removeAttr('disabled').removeClass('disabled');
    $('.build--step.active .build--overview__items').css('justify-content','space-between');

  var $activeStep = $('.build--step.active:not(.summary)');
   // console.log( $activeStep.find('.overview-item[data-id="' + id + '"]'), "active step length");
   var $allMatchingItems = $('.overview-item[data-id="' + id + '"]');

  if ($activeStep.find('.overview-item[data-id="' + id + '"]').length > 0) {
     $allMatchingItems.each(function () {
        const $item = $(this);
      let count = parseInt($item.find('.overview--count').text()) || 0;
      let newCount = count + 1;

      // Update count display
      $item.find('.overview--count').text(newCount);

      // Update input value
      $item.find('.quantity .quantity__input')
        .val(newCount)
        .attr('value', newCount);


       updateLocalStorage(id, product,image,price,newCount)
    });
    } else {
      $('.build--step.active:not(.summary) .build--overview__wrap').prepend('<div class="overview-item" data-price="' + price.replace('$','') + '" data-id="' + id + '"> <div class="overview--image"><img loading="lazy" src="' + image + '"/><small class="overview--count">1</small></div><div class="overview--info"> <h3 class="overview--title">' + product + '</h3> <div class="overview--flex"> <span class="overview--price">' + price + '</span> <div class="card--quantity"><div class="product-form__input product-form__quantity"> <div class="quantity overview-qty" data-image="' + image + '" data-product="' + product + '" data-id="' + id + '" data-price="' + price + '"> <button class="quantity__button box no-js-hidden" name="minus" type="button"> <span class="visually-hidden">Decrease quantity for ' + product + '</span><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"></path></svg> </button> <input class="quantity__input" type="number" name="quantity" value="1"> <button class="quantity__button box no-js-hidden" name="plus" type="button"> <span class="visually-hidden">Increase quantity for </span> <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10"><path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"></path></svg> </button> </div> </div></div></div></div></div>');
       updateLocalStorage(id, product,image,price,1)
    }

    //Computation of items in total
    var prices = new Array();
    pricing = [];

    $('.build--step.active:not(.summary) .overview-item').each(function(){
      var count = Math.ceil($(this).find('.overview--count').text());
      prices.push(parseFloat($(this).data('price')) * count);
      pricing.push(parseFloat($(this).data('price')));
    });

    ctr++;
    var amount = pricing.reduce((pricing, x) => pricing + x);
    $('.stick__buttons').find('.product--count').empty().text(`${ctr} Items`);
    $('.stick__buttons').find('.cart--count a').empty().text('VIEW CART (' + ctr + ')');

    var total = prices.reduce((partialSum, a) => partialSum + a, 0);
    $('.build--step.active .overview--total span').empty().text('$' + total.toFixed(2));
    $('.activeSelection .overview--total span').empty().text('$' + total.toFixed(2));
    $('.stick__buttons').find('.product--pricing').empty().text('$' + amount.toFixed(2));
    $('.stick__buttons').find('.overview--total span').empty().text('$' + total.toFixed(2));
    $('.build--overviewcontent-empty p').text("");

    if($('.build--step.active .build--overview__wrap').children().length > 0){
      $('.stick__buttons').css('visibility', 'visible');
    }
   window.updateDestinationTrail();
  });



$(document).on("click", '.quantity__button.box[name="minus"]', function(){
    var id = $(this).parent().data('id');
  var image = $(this).parent().data('image');
  var product = $(this).parent().data('product');
  var price = $(this).parent().data('price');

  var $activeStep = $('.build--step.active:not(.summary)');
  var $allMatchingItems = $('.overview-item[data-id="' + id + '"]');

  if ($activeStep.find('.overview-item[data-id="' + id + '"]').length > 0) {
    $allMatchingItems.each(function () {
      const $item = $(this);
      let count = parseInt($item.find('.overview--count').text()) || 0;
      let newCount = Math.max(count - 1,0);

      if (newCount <= 0) {
        $item.remove(); // Remove from DOM
        updateLocalStorage(id, product, image, price, 0)
      } else {
        $item.find('.overview--count').text(newCount); // Update count
        $item.find('.quantity .quantity__input')
          .val(newCount)
          .attr('value', newCount);

        updateLocalStorage(id, product, image, price, newCount)

      }
    });
  }

  // 5. Recalculate total
  let prices = [];
  pricing = [];
  $('.build--step.active:not(.summary) .overview-item').each(function(){
    const count = Math.ceil($(this).find('.overview--count').text());
    prices.push(parseFloat($(this).data('price')) * count);
    pricing.push(parseFloat($(this).data('price')));
  });

  ctr = Math.max(0, ctr - 1);
  var amount = pricing.length > 0 ? pricing.reduce((acc, x) => acc + x, 0) : 0;
    $('.stick__buttons').find('.product--count').empty().text(`${ctr} Items`);
    $('.stick__buttons').find('.cart--count a').empty().text('VIEW CART (' + ctr + ')');

    var total = prices.reduce((partialSum, a) => partialSum + a, 0);
    $('.build--step.active .overview--total span').empty().text('$' + total.toFixed(2));
    $('.activeSelection .overview--total span').empty().text('$' + total.toFixed(2));
    $('.stick__buttons').find('.product--pricing').empty().text('$' + amount.toFixed(2));
    $('.stick__buttons').find('.overview--total span').empty().text('$' + total.toFixed(2));
    $('.build--overviewcontent-empty p').text("");
  

  // 6. Hide bar if empty
  if($('.build--step.active .build--overview__wrap').children().length <= 0){
    $('.stick__buttons').css('visibility', 'hidden');
  } else {
    $('.stick__buttons').css('visibility', 'visible');
  }
    window.updateDestinationTrail();
});


  

  $('.step--button.cart').click(function() {
    // var ids = [];
    // var qtys = [];
    // var props = [];
    // var data = [];
    var items = '';

    var local = [89431, 89433, 89434, 89436, 89441, 89501, 89502, 89521, 89439, 89503, 89506, 89508, 89509, 89511, 89512, 89519, 89523];
    var zip = localStorage.getItem('buildabox_zip');
    zip = parseInt(zip); // Make sure it's a number for includes()

    var total = $('.overview--total > span').html();
    var price = Number(total.replace(/[^0-9\.-]+/g,""));
    var min ;
    var balance;

    $('.build--step.summary .overview-item').each(function(){
      // console.log("cart ids", $(this).data('id'))
      items += $(this).data('id') + ':' + Math.ceil($(this).find('.overview--count').text()) + ',' ;
    });
  
    // console.log(zip);
    console.log("total price meant for cart",price);

    if(local.includes(zip) && price < 60) {
      min = 60;
      balance = 60 - price
      // $('.build__last-error').text("Minimum order value should be $" + min);
      $('.build__last-error').text("you are $" + balance + "away from the $60 minimum order required for delivery.");
      $('.build__last-error').show().addClass('shake');
       setTimeout(() => {
        $('.build__last-error').removeClass('shake').hide();
      }, 400); 
    } else if(!local.includes(zip) && price < 175) { 
      min = 175;
      balance = 175 - price
      // $('.build__last-error').text("Minimum order value should be $" + min);
      $('.build__last-error').text("you are $" + balance + " away from the $175 minimum order required for delivery.");
        $('.build__last-error').show().addClass('shake');
       setTimeout(() => {
        $('.build__last-error').removeClass('shake').hide();
      }, 1200);
    } else {
        // $('.build__last-error').hide().text(`You’ve reached the ${min} minimum — you’re good to go!');
      window.location.href = 'https://motherofmacros.myshopify.com/cart/' + '40914461425700:1,' + items;
      $(this).text('ADDING ITEMS TO CART...');
    }

    // jQuery.ajax({
    //   type: 'POST',
    //   url: '/cart/add.js',
    //   data: { items: data },
    //   dataType: 'json',
    //   success: function() {
    //   setTimeout(function() {
    //     window.location.href = '/cart';
    //    }, 1000);
    //   },
    //   error: function (error) {
    //     alert(error.responseJSON['description']);
    //   }
    // });
  });

  $('#step0').on('click', function(){
    $('#step1, #step2, #step3, #step4').removeClass('active');
    $('#step1, #step2, #step3, #step4').removeClass('finished');
    $(".product--selection").hide();
    $(this).removeClass('finished').addClass('active');
    $("section[id*=product-grid-1]").css({'display': 'none'});
    $("section[id*=product-grid-2]").css({'display': 'none'});
    $('[data-step="4"]').css({'display':'none'});
    $(".build--box").css('display', 'block');
    $('[data-step="0"]').css({'display': 'block'});
    $('[data-step="1"]').css({'display': 'none'});
    $('[data-step="3"]').css({'display': 'none'});
    $('.build--overviewcontent-empty p').text("");
  });

  $('#step1').on('click', function(){
    $('#step0, #step2, #step3, #step4').removeClass('active');
    $('#step2, #step3, #step4').removeClass('finished');
    $(".product--selection").hide();
    $(this).removeClass('finished').addClass('active');
    $("section[id*=product-grid-1]").css({'display': 'none'});
    $("section[id*=product-grid-2]").css({'display': 'none'});
    $('[data-step="4"]').css({'display':'none'});
    $(".build--box").css('display', 'block');
    $('[data-step="0"]').css({'display': 'none'});
    $('[data-step="1"]').css({'display': 'block'});
    $('.build--overviewcontent-empty p').text("");
  });


  $('#step2').on('click', function(){

    var plan = $(".plan-flex input[type=radio]:checked").val();
    if(plan == 'one-time') {
      $('#step0, #step1').removeClass('active').addClass('finished');
      $('#step3, #step4').removeClass('finished');
      $('#step3, #step4').removeClass('active');

      $(this).removeClass('finished').addClass('active');
      $("section[id*=product-grid-1]").css({'display': 'flex', 'justify-content': 'center'});
      $("section[id*=product-grid-2]").css({'display': 'none'});
      $(".build--box").css('display', 'none');
      $('[data-step="0"]').css({'display': 'none'});
      $('[data-step="1"]').css({'display': 'none'});
      $('[data-step="2"]').addClass('active');
    }  else {
      alert('Please select a plan.');
      $('.build--overviewcontent-empty p').text("");
    }

  });

  $('#step3').on('click', function(){

    if( $(this).hasClass('finished') ){
      $('#step4').removeClass('active');
        $('#step3').removeClass('active, finished');
        $(this).removeClass('finished').addClass('active');
        $("section[id*=product-grid-1]").css({'display': 'none'});
        $("section[id*=product-grid-2]").css({'display': 'flex', 'justify-content': 'center'});
        $(".build--box").css('display', 'none');
        $('[data-step="2"]').removeClass('active');
        $('[data-step="3"]').addClass('active');
    } else{
        $('.build--overviewcontent-empty p').text("");
        $('#step2').removeClass('active').addClass('finished');
        $('#step3').removeClass('active, finished');
        $(this).removeClass('finished').addClass('active');
        $("section[id*=product-grid-1]").css({'display': 'none'});
        $("section[id*=product-grid-2]").css({'display': 'flex', 'justify-content': 'center'});
        $(".build--box").css('display', 'none');
        $('[data-step="2"]').removeClass('active');
        $('[data-step="3"]').addClass('active');
    }
  });

  $('#step4').on('click', function(){
    if($('[data-step="3"].active .build--overview__wrap').children().length <= 0 ) {

      $('.build--overviewcontent-empty p').text("Please proceed to Clean Cheatz before proceeding to order summary.");
    } else{
      $('.build--overviewcontent-empty p').text("");
      $('#step3').removeClass('active').addClass('finished');
      $(this).removeClass('finished').addClass('active');
      $("section[id*=product-grid-1]").css({'display': 'none'});
      $("section[id*=product-grid-2]").css({'display': 'none'});
      $(".build--box").css('display', 'block');
      $('[data-step="2"]').removeClass('active');
      $('[data-step="3"]').removeClass('active');
      $('[data-step="4"]').addClass('active');
      $('[data-step="4"]').css({'display': 'block'});

      $('[data-step="0"]').css({'display': 'none'});
      $('[data-step="1"]').css({'display': 'none'});


      //ADDS ALL ITEMS ON PREVIOUS STEPS
      var prices = new Array();
      $('.build--step.summary .build--overview__wrap').empty();
      $('.build--overview__wrap .overview-item').each(function(){
        $('.build--step.summary .build--overview__wrap').append(this.outerHTML);
        var count = Math.ceil($(this).find('.overview--count').text());
        prices.push(parseFloat($(this).data('price')) * count);
      });

      var total = prices.reduce((partialSum, a) => partialSum + a, 0);
      $('.build--step.active .overview--total span').empty().text('$' + total.toFixed(2));
    }
  });

  // Displays product count on product quickview
  $('.modal.quickview').on($.modal.BEFORE_OPEN, function(event, modal) {
    var product = $(this).data('product');
    var count = Math.ceil($('.overview-item[data-id="' + product + '"] .overview--count').text());


    if(count <= 2) {
      $(this).find('.product__count').text(count + ' product added');
    } else if (count > 2) {
      $(this).find('.product__count').text(count + ' products added');
    }
  });

  var filterElements = document.querySelectorAll('.filters-select');

  // Add click event listener to each filter element
  filterElements.forEach(function(element) {
    element.addEventListener('click', function() {
      // Toggle the class 'activeFilter'
      this.classList.toggle('activeFilter');
    });
  });
});